import { getColorClassName, } from "../../objects/facets/Color";
/**
 * Returns background's classname depending on background type
 * @param backgroundType {string} - BackgroundType
 * @returns {string} - Background Color value
 */
export var getBackgroundClassName = function (backgroundType) {
    return "background-".concat(getColorClassName(backgroundType));
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQmFja2dyb3VuZC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL29iamVjdHMvYXRvbXMvQmFja2dyb3VuZC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUUsaUJBQWlCLEdBQXFDLE1BQU0sd0JBQXdCLENBQUE7QUFXN0Y7Ozs7R0FJRztBQUNILE1BQU0sQ0FBQyxJQUFNLHNCQUFzQixHQUFHLFVBQ3BDLGNBQWtEO0lBRWxELE9BQU8scUJBQWMsaUJBQWlCLENBQUMsY0FBYyxDQUFDLENBQUUsQ0FBQTtBQUMxRCxDQUFDLENBQUEifQ==